(() => {
  const styleId = 'ev-product-details-style';
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const sectionOrder = ['Description', 'How to Personalize', 'Shipping & Production', 'FAQ'];
  const subtitles = {
    Description: 'A unique wood slice keepsake, engraved with your favorite photo and custom text.',
    'How to Personalize': 'Upload your photo, choose a font, and add your custom text.',
    'Shipping & Production': 'Crafted and shipped with care from our studio to your door.',
    FAQ: 'Answers to common questions.'
  };
  const fallbackBodies = {
    'How to Personalize': 'Upload your photo or reference image, enter names or a short message, choose your preferred font, and add any special notes before adding to cart.',
    'Shipping & Production': 'Each piece is made to order after your personalization details are received. Production and delivery times may vary by destination.',
    FAQ: 'For best results, upload a clear, bright photo. Add any placement, wording, or gift notes in the order notes field.'
  };

  const injectStyle = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .ev-product__gallery-hint {
        display: none !important;
      }

      .ev-product__price--bestcustom {
        margin: 12px 0 22px;
      }

      .ev-product__price--bestcustom .ev-price {
        color: var(--ev-accent, #f1641e);
        font-size: clamp(24px, 2.1vw, 29px);
        line-height: 1.08;
        font-weight: 900;
      }

      .ev-product__price--bestcustom .ev-price-compare {
        font-size: 0.72em;
      }

      @media (max-width: 749px) {
        .ev-product__price--bestcustom .ev-price {
          font-size: clamp(22px, 6.2vw, 26px);
        }
      }

      .ev-product__description--enhanced {
        margin-top: 18px;
        border: 0;
        padding: 0;
      }

      .ev-product__accordion-list {
        display: grid;
        gap: 10px;
      }

      .ev-product__details {
        border: 1px solid rgba(47, 41, 36, 0.14);
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.98);
        overflow: hidden;
      }

      .ev-product__details-summary {
        display: grid;
        grid-template-columns: 30px minmax(0, 1fr) 18px;
        align-items: center;
        gap: 12px;
        min-height: 68px;
        padding: 13px 16px;
        cursor: pointer;
        list-style: none;
        color: #2f2924;
      }

      .ev-product__details-summary::-webkit-details-marker {
        display: none;
      }

      .ev-product__details-leading {
        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 9px;
        background: #fff4ec;
        border: 1px solid #eadbd0;
      }

      .ev-product__details-leading::before,
      .ev-product__details-leading::after {
        position: absolute;
        content: "";
        background: #c55a22;
      }

      .ev-product__details-leading::before {
        top: 9px;
        left: 8px;
        width: 14px;
        height: 2px;
        border-radius: 999px;
      }

      .ev-product__details-leading::after {
        top: 14px;
        left: 8px;
        width: 10px;
        height: 2px;
        border-radius: 999px;
      }

      .ev-product__details-title {
        display: block;
        font-size: 15px;
        font-weight: 850;
        line-height: 1.25;
      }

      .ev-product__details-subtitle {
        display: block;
        margin-top: 3px;
        color: #6f625a;
        font-size: 13px;
        line-height: 1.4;
      }

      .ev-product__details-arrow {
        width: 10px;
        height: 10px;
        border-right: 2px solid #6f625a;
        border-bottom: 2px solid #6f625a;
        transform: rotate(45deg);
        transition: transform 160ms ease;
      }

      .ev-product__details[open] .ev-product__details-arrow {
        transform: rotate(-135deg);
      }

      .ev-product__details-body {
        padding: 0 16px 17px 58px;
        color: #4b4038;
        font-size: 14px;
        line-height: 1.65;
      }

      .ev-product__details-body > :first-child {
        margin-top: 0;
      }

      .ev-product__details-body > :last-child {
        margin-bottom: 0;
      }

      @media (min-width: 990px) {
        .ev-product__gallery-shell {
          display: grid;
          grid-template-columns: 72px minmax(0, 1fr);
          align-items: start;
          gap: 14px;
        }

        .ev-product__thumbs--bestcustom {
          display: grid;
          grid-template-columns: 1fr;
          align-content: start;
          gap: 10px;
          width: 72px;
          max-height: var(--ev-product-stage-height, 560px);
          margin: 0;
          padding: 2px 5px 2px 2px;
          overflow-x: hidden;
          overflow-y: auto;
          scrollbar-width: thin;
        }

        .ev-product__thumb-button {
          width: 62px;
          height: 62px;
          flex: 0 0 62px;
          padding: 0;
          border: 1px solid #eadbd0;
          border-radius: 10px;
          background: #fff;
          overflow: hidden;
        }

        .ev-product__thumb-button.is-active,
        .ev-product__thumb-button[aria-pressed="true"] {
          border-color: var(--ev-accent, #f1641e);
          box-shadow: 0 0 0 2px rgba(241, 100, 30, 0.22);
        }

        .ev-product__thumb-media,
        .ev-product__thumb-media img {
          width: 100%;
          height: 100%;
          display: block;
        }

        .ev-product__thumb-media img {
          object-fit: cover;
          border-radius: 9px;
        }

        .ev-product__stage {
          min-width: 0;
          align-self: start;
        }
      }

      @media (max-width: 989px) {
        .ev-product__thumbs--bestcustom {
          display: none !important;
        }

        .ev-product__gallery-shell {
          display: block;
        }

        .ev-product__description--enhanced {
          margin-top: 14px;
        }

        .ev-product__details-summary {
          grid-template-columns: 28px minmax(0, 1fr) 16px;
          min-height: 64px;
          padding: 12px 14px;
        }

        .ev-product__details-leading {
          width: 28px;
          height: 28px;
        }

        .ev-product__details-title {
          font-size: 14px;
        }

        .ev-product__details-subtitle {
          font-size: 12.5px;
        }

        .ev-product__details-body {
          padding: 0 14px 15px 54px;
          font-size: 13.5px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const normalize = (value) => value.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();

  const canonicalTitle = (text) => {
    const normalized = normalize(text);
    if (!normalized) return '';
    if (normalized === 'description' || normalized === 'product description') return 'Description';
    if (normalized.includes('personalize') || normalized.includes('personalise')) return 'How to Personalize';
    if (normalized.includes('shipping') || normalized.includes('production') || normalized.includes('delivery')) return 'Shipping & Production';
    if (normalized === 'faq' || normalized.includes('question')) return 'FAQ';
    return '';
  };

  const isSectionHeading = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return '';
    const tagName = node.tagName.toLowerCase();
    const text = node.textContent.trim();
    if (!text || text.length > 80) return '';

    const title = canonicalTitle(text);
    if (!title) return '';
    if (/^h[1-6]$/.test(tagName)) return title;
    if (['p', 'div', 'strong', 'b'].includes(tagName) && normalize(text) === normalize(title)) return title;
    return '';
  };

  const hasReadableContent = (nodes) => nodes.some((node) => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim().length > 0;
    if (node.nodeType === Node.ELEMENT_NODE) return node.textContent.trim().length > 0 || node.querySelector('img, video, iframe');
    return false;
  });

  const addSection = (sections, title, nodes) => {
    if (!title || !hasReadableContent(nodes)) return;
    if (!sections.has(title)) sections.set(title, []);
    sections.get(title).push(...nodes);
  };

  const extractSections = (body) => {
    const sections = new Map();
    let activeTitle = 'Description';
    let activeNodes = [];

    Array.from(body.cloneNode(true).childNodes).forEach((node) => {
      const headingTitle = isSectionHeading(node);
      if (headingTitle) {
        addSection(sections, activeTitle, activeNodes);
        activeTitle = headingTitle;
        activeNodes = [];
        return;
      }

      activeNodes.push(node);
    });

    addSection(sections, activeTitle, activeNodes);

    if (!sections.has('Description') && hasReadableContent(Array.from(body.cloneNode(true).childNodes))) {
      sections.set('Description', Array.from(body.cloneNode(true).childNodes));
    }

    return sections;
  };

  const createSummary = (titleText, subtitleText) => {
    const summary = document.createElement('summary');
    summary.className = 'ev-product__details-summary';

    const leading = document.createElement('span');
    leading.className = 'ev-product__details-leading';
    leading.setAttribute('aria-hidden', 'true');

    const text = document.createElement('span');
    text.className = 'ev-product__details-text';

    const title = document.createElement('span');
    title.className = 'ev-product__details-title';
    title.textContent = titleText;

    const subtitle = document.createElement('span');
    subtitle.className = 'ev-product__details-subtitle';
    subtitle.textContent = subtitleText;

    const arrow = document.createElement('span');
    arrow.className = 'ev-product__details-arrow';
    arrow.setAttribute('aria-hidden', 'true');

    text.append(title, subtitle);
    summary.append(leading, text, arrow);
    return summary;
  };

  const createBodyFromNodes = (nodes) => {
    const body = document.createElement('div');
    body.className = 'ev-product__details-body rte';
    nodes.forEach((node) => body.append(node.cloneNode(true)));
    return body;
  };

  const createBodyFromText = (text) => {
    const body = document.createElement('div');
    body.className = 'ev-product__details-body rte';
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    body.append(paragraph);
    return body;
  };

  const enhanceDescriptions = () => {
    const descriptions = document.querySelectorAll('.ev-product__description');
    if (!descriptions.length) return;

    descriptions.forEach((container) => {
      if (container.dataset.evDetailsEnhanced === 'true') return;

      const body = container.querySelector('.ev-product__description-body');
      if (!body) return;

      const sections = extractSections(body);
      const list = document.createElement('div');
      list.className = 'ev-product__accordion-list';

      sectionOrder.forEach((title) => {
        const nodes = sections.get(title);
        if (!nodes && title === 'Description') return;

        const details = document.createElement('details');
        details.className = 'ev-product__details';
        details.append(createSummary(title, subtitles[title]));

        if (nodes && hasReadableContent(nodes)) {
          details.append(createBodyFromNodes(nodes));
        } else {
          details.append(createBodyFromText(fallbackBodies[title] || subtitles[title]));
        }

        list.append(details);
      });

      container.replaceChildren(list);
      container.classList.add('ev-product__description--enhanced');
      container.dataset.evDetailsEnhanced = 'true';
    });
  };

  const syncThumbRails = () => {
    document.querySelectorAll('.ev-product__gallery-shell').forEach((shell) => {
      const rail = shell.querySelector('.ev-product__thumbs--bestcustom');
      const stage = shell.querySelector('.ev-product__stage');
      if (!rail || !stage) return;

      if (!desktopQuery.matches) {
        shell.style.removeProperty('--ev-product-stage-height');
        rail.style.removeProperty('max-height');
        return;
      }

      const height = Math.round(stage.getBoundingClientRect().height);
      if (height > 0) {
        shell.style.setProperty('--ev-product-stage-height', `${height}px`);
        rail.style.maxHeight = `${height}px`;
      }
    });
  };

  const scheduleThumbSync = () => {
    window.requestAnimationFrame(() => {
      syncThumbRails();
      window.setTimeout(syncThumbRails, 180);
    });
  };

  const init = () => {
    injectStyle();
    enhanceDescriptions();
    scheduleThumbSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', scheduleThumbSync, { once: true });
  window.addEventListener('resize', scheduleThumbSync);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.ev-product__thumb-button, .ev-product__gallery-arrow, [data-option-picker-option]')) {
      scheduleThumbSync();
    }
  });
  document.addEventListener('shopify:section:load', init);
})();
